import { Fov } from "../../Model/ModuleState";
import { HistogramData } from "../../Model/HistogramData";

export enum ELiveImageAction {
  SET_SHOW_CROSSHAIR = "SET_SHOW_CROSSHAIR",
  SET_SHOW_RULER = "SET_SHOW_RULER",
  SET_SHOW_WELL_OVERLAY = "SET_SHOW_WELL_OVERLAY",
  // SET_FOV = "SET_FOV",
  SET_HISTOGRAM = "SET_HISTOGRAM",
  SET_LIVE_IMAGE_CROP_ZOOM = "SET_LIVE_IMAGE_CROP_ZOOM",
}

export interface LiveImageAction {
  type: ELiveImageAction;
  histogramData?: HistogramData;
  showCrosshair?: boolean;
  showRuler?: boolean;
  showWellOverlay?: boolean;
  fov?: Fov;
  liveImageCropZoomX?: number;
  liveImageCropZoomY?: number;
}

export function setHistogramData(histogramData: HistogramData): LiveImageAction {
  return {
    type: ELiveImageAction.SET_HISTOGRAM,
    histogramData: histogramData,
  };
}

export function setShowCrossHair(showCrosshair: boolean): LiveImageAction {
  return {
    type: ELiveImageAction.SET_SHOW_CROSSHAIR,
    showCrosshair: showCrosshair,
  };
}

export function setShowRuler(showRuler: boolean): LiveImageAction {
  return {
    type: ELiveImageAction.SET_SHOW_RULER,
    showRuler: showRuler,
  };
}

export function setShowWellOverlay(showWellOverlay: boolean): LiveImageAction {
  return {
    type: ELiveImageAction.SET_SHOW_WELL_OVERLAY,
    showWellOverlay: showWellOverlay,
  };
}

// export function setFov(fov: Fov): LiveImageAction {
//   return {
//     type: ELiveImageAction.SET_FOV,
//     fov: fov,
//   };
// }

export function setLiveImageCropZoom(x: number, y: number): LiveImageAction {
  return {
    type: ELiveImageAction.SET_LIVE_IMAGE_CROP_ZOOM,
    liveImageCropZoomX: x,
    liveImageCropZoomY: y,
  };
}
